import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <h5>Study Area</h5>
            <p>
              Tumkur district covers a 10,597 sq. km area, and is located at 12
              <sup>0</sup> 45' to 14<sup>0 </sup>22' N 76<sup>0</sup> 24' to 77
              <sup>0</sup> 30' E (Figure 1). Chikkamagaluru district surrounds
              the Tumkur district on the northeast side, Chitradurga and Hassan
              districts in the west, Mandya district on the south, and Anantapur
              district of Andhra Pradesh state in the southeast. The district
              has been divided into 10 taluks: Tumkur, Madhugiri, Pavagada,
              Koratagere, Sira, Tiptur, Gubbi, Turuvekere Kunigal,
              Chikkanayakanahalli for efficient administration. The district has
              a population of 28,82,849 (2021), with a growth rate of 0.9% and
              has a density of 273 persons/km<sup>2</sup>. The Gross District
              Domestic Product (GDDP) accounts for 57145 crores (571.45 billion
              rupees), contributing 3.9% of Karnataka state&rsquo;s Net State
              Domestic Product. Tumkur city (capital of the Tumkur district)
              infrastructure has been upgraded under the smart city mission in
              Karnataka.
            </p>
            <p>
              The districts have an agricultural-friendly geomorphological and
              soil composition. Tumkur is covered by denudational uplands on
              gneisses and granites most of the area. The region receives an
              average rainfall of 780 mm. The important irrigated crops are
              paddy, jowar, bajra, maize, ragi, wheat, etc. Major horticultural
              crops are coconut, ground nut, sunflower, safflower, and castor.
              Major rivers draining the agriculture fields are Jayamangala,
              Kumudvathi, Vedavathi, Suvarnamukhi, and Shimsha. None of these
              rivers are perennial due to catchment degradation&nbsp; with the
              sustained anthropogenic pressures. Borewells are the primary
              source for drinking water supply and irrigation. Livestock
              includes 5,27,067 Cattles, 1,81,118 Buffaloes, 10,61,330
              Sheep&rsquo;s, 3,26,890 Goats, 7,122 pigs and 21,07,798 poultry.
              The tourism sector attracts a large population inflow due to
              Devarayan Durga temples, Shanishvara temple, Pavagada fort,
              Siddaganga Mutt, Siddara Betta, Yediyur, Kaggaladu Bird Sanctuary,
              Marconahalli, etc. The district shelters 37 large scale, 28 medium
              scale, 309 small scale, &nbsp;28452 microscale industries, and 7
              industrial estates. Industries such as Hoidel Berg Cement India
              Ltd., Turuvekere, HMT Watch Factory Ltd, Tumkur Mann &amp; Hummen
              Filter Pvt Ltd. Support livelihood for thousands of people. The
              world&rsquo;s third-largest solar park (photovoltaic) is situated
              in the Pavagada region, covering 13,000 acres of the district with
              a capacity of &nbsp;2,050 MW.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl1.png" alt="" />{" "}
            </p>
            <p style={{ textAlign: "center" }}>
              Figure 1. Study area, Tumkur district
            </p>
            <h5>Method</h5>
            <h6>
              {" "}
              <b>
                Quantification of landscape dynamics and assessing spatial
                configuration through metrics
              </b>
            </h6>
            <p>
              The primary data (RS data of 30 m spatial resolution) is collected
              from Landsat archives available in public domains from 1989 to
              2019. Pre-processing of RS data has been done to maintain
              geometrical and radiometric consistency. The secondary data used
              in the analysis includes survey of India (SoI) toposheets of
              1:50000 and 1:250000 scales, administrative reports, and virtual
              earth data sets (BHUVAN; Openlayers; Google Earth). The training
              data has been collected from the field using a hand-held global
              position system (GPS) instrument covering distinct landscape
              features across the district. LC change has been evaluated through
              NDVI measure, which provided area coverage under vegetation, and
              non-vegetation based on spectral reflectance property. The range
              of NDVI for a given pixel is -1 to +1 as per equation 1. LU
              analysis has been carried out using supervised classification
              techniques such as Gaussian maximum likelihood classifier (GMLC),
              which accounts for the probability and cost functions, proved
              efficient compared to other algorithms. 60% of the training data
              collected from the field has been used for RS data classification,
              rest of the 40% was used for the accuracy assessment. The
              classification accuracy (Overall Accuracy (OA), Producer accuracy
              (PA), User Accuracy (UA)) was estimated using reference data by
              assessing Kappa statistics and overall accuracy.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl1.png" alt="" />
              ........(1){" "}
            </p>
            <p>
              Landscape&rsquo;s status has been valued through fragmentation
              analysis and spatial metrics. The spatial metrics calculated at
              the grid level were computed to assess the landscape configuration
              (Aithal et al., 2012) through the software Fragstat. The details
              of the metrics calculated are presented in Table 1. Temporal LU
              data has aided in assessing fragmentation under various categories
              based on P<sub>f</sub> and P<sub>ff</sub> indicators by using a
              5&times;5 kernel as depicted in equations 2 and 3 (Riitters et
              al., 2000). The categories include &ldquo;Interior forest (P
              <sub>f</sub>=1; i.e., all pixels in the neighboring area are
              forest); Edge forest (P<sub>f </sub>&gt; 0.6 and P<sub>f</sub>
              &ndash;P<sub>ff</sub> &lt; 0; i.e.,&nbsp; the majority of the
              pixels in the neighbouring area are forest but pixels were
              appearing along the boundary of the non-forest categories such as
              built-up area, or agriculture), Perforated forest (P<sub>f</sub>{" "}
              &gt; 0.6 and P<sub>f</sub>&ndash;P<sub>ff</sub> &gt; 0; most of
              the pixels in the surrounding area were forested, but they appear
              to be part of the inside edge of a forest patch, or a small
              clearing was done inside a patch), Patch forest (P<sub>f</sub>{" "}
              &lt; 0.4; i.e., only few forest pixels were present as an isolated
              segment on a non-forest category), Transitional forest (0.4 &lt; P
              <sub>f</sub> &lt; 0.6; i.e., half of the neighbouring pixels were
              forest, and they may be found as a part of a patch, edge, or
              perforation subjected to the spatial pattern of forest
              sampled)&rdquo;. The study area was divided into 5&rsquo;
              &nbsp;5&rsquo; or 9 &nbsp;9 km<sup>2 </sup>uniform grids
              comparable to the SOI 1:50000 scale toposheet divisions.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl2and3.png" alt="" />{" "}
            </p>

            <p>Table 1. Spatial metrics assessed</p>
            <table width="103%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>
                      <strong>Indicator</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="42%">
                    <p>
                      <strong>Formula</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="16%">
                    <p>
                      <strong>Scale</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="25%">
                    <p>
                      <strong>Justification</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>CA: Class Area</p>
                  </td>
                  <td style={styles.cell} width="42%">
                    <p>------</p>
                  </td>
                  <td style={styles.cell} width="16%">
                    <p>&gt; 0</p>
                  </td>
                  <td style={styles.cell} width="25%">
                    <p>Overall LU class area expressed in hectares</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>NP: Number of Patches</p>
                  </td>
                  <td style={styles.cell} width="42%">
                    <p>NP = n</p>
                    <p>NP equals the number of patches in the landscape.</p>
                  </td>
                  <td style={styles.cell} width="16%">
                    <p>NP &gt; 0, without limit</p>
                  </td>
                  <td style={styles.cell} width="25%">
                    <p>
                      It signifies fragmentation property based on the number of
                      patches accounted in a landscape. The higher the value,
                      the greater the fragmentation and vice versa
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>AI: Aggregation Index</p>
                  </td>
                  <td style={styles.cell} width="42%">
                    <p>
                      LA<sub>ii</sub> = number of like adjacencies (joins)
                      between pixels of patch type (class) I based on the
                    </p>
                    <p>single count method.</p>
                    <p>
                      max-LA<sub>ii</sub> = maximum number of like adjacencies
                      (joins) between pixels of patch type class i based on
                      single count method.
                    </p>
                    <p>
                      P<sub>i</sub> = proportion of landscape comprised of patch
                      type (class) i.
                    </p>
                  </td>
                  <td style={styles.cell} width="16%">
                    <p>1 &le; AI &le; 100</p>
                  </td>
                  <td style={styles.cell} width="25%">
                    <p>
                      AI value represents the grid's agglomeration and
                      scattering of patches. AI corresponds to 1 as maximally
                      disaggregated and 100 as maximally aggregated into a
                      single compact patch.
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="15%">
                    <p>NLSI: Normalized Landscape Shape Index</p>
                  </td>
                  <td style={styles.cell} width="42%">
                    <p>
                      Where a<sub>i </sub>and p<sub>i</sub> are the area and
                      perimeter of patch i, and NP is the total number of
                      patches.
                    </p>
                  </td>
                  <td style={styles.cell} width="16%">
                    <p>0 &le; NLSI &lt; 1</p>
                  </td>
                  <td style={styles.cell} width="25%">
                    <p>
                      Shape complexity is bestowed with the NLSI index.
                      Increases for greater disaggregation and becomes 0 when
                      the landscape consists of compact or a single square
                      patch.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <h5>
              Modeling of landscape dynamics through hybrid Fuzzy AHP Markov CA
            </h5>
            <p>
              Modeling landscape dynamics is implemented using Fuzzy AHP Markov
              CA by considering&nbsp; (i) Markov Chain (MC) based transitions
              from earlier LU data, (ii) estimating the influences of driving
              factors and constraints, (iii) weightage metric score constructed
              through fuzzy AHP and site suitability maps creation with MCE,
              (iv) simulation and future prediction of LU by MC-CA algorithms.
              Probable LU for the year 2029 is calculated as outlined in Figure
              2. Socio-economic factors influencing LU, including proximity to
              roads, bus stations, city centers, industries, schools, and social
              amenities, were considered. Constraints considered for LU
              transition were water bodies, reserved forest, slope, elevation,
              and wildlife sanctuaries.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/tl2.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              Figure 2 Method utilized for the analyses
            </p>
            <p>
              LU of 1999, and 2009 were utilized for MC analysis to compute the
              transition probability. MC reveals the transfer rate among the two
              different LU classes (Sang et al., 2011; dos Santos et al., 2015).
              The transition probability (TP) for a class i and j can be
              calculated by
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl4.png" alt="" />
              ........(4){" "}
            </p>

            <p>
              where n<sub>i</sub> is the total number of pixels of class i
              transformed over the transition period, n<sub>ij</sub> is the
              number of pixels transformed from class i to j. The distribution
              of each LU class at time t+1 is derived with the help of M
              <sub>t</sub> &nbsp;i.e., LU distribution at the beginning time t
              as,
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl5.png" alt="" />
              ........(5){" "}
            </p>

            <p>The transition matrix can be show as</p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl6.png" alt="" />
              ........(6){" "}
            </p>

            <p>
              This calculated transition matrix then used as rate of change to
              predict the future LU (N. Jespersen, 2015).To find out n
              <sup>th</sup> growth rate, let P be the transition matrix of a
              Markov Chain, and let U be the probability vector that represents
              the early distribution. Then the probability that the chain is in
              the state S<sub>i</sub> after n steps is the i<sup>th</sup> entry
              in the vector (W. Stewart, 1995)
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl7.png" alt="" />
              ........(7){" "}
            </p>

            <p>
              The contributing factors influence on LU transition were accounted
              by normalizing between 0 and 255 through fuzzification, where 255
              indicates the maximum probability of change, while 0 indicates of
              no changes. AHP has been aided for producing the pair-wise
              comparison matrices depicting relative weights as Eigenvectors
              (Bernasconi et al., 2010) to determine the degree of significance
              between factors i and j on LU transition. A response matrix R = [r
              <sub>ij</sub>] is constructed to quantify the relative dominance
              of items i over j with the decision make&rsquo;'s assessments,
              which adhere to a uniform probability distribution.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl42.png" alt="" />
              ........(4){" "}
            </p>

            <p>
              where, W<sub>i</sub> and W<sub>j </sub>are the priority weights
              belonging to vector W and =1, &nbsp;is inconsistency observed in
              the analysis. The consistency ratio, and consistency index were
              &nbsp;calculated to estimate the consistency of the judgment
              matrix by comparing it with random index and maximum eigenvalues.
              Site suitability map has been generated with the aid of MCE and
              provided as an input for MCA-based prediction.
            </p>
            <h5>Conservation of landscape through ESR prioritization</h5>
            <p>
              ESRs were identified at the grid level by applying aggregated
              weight criteria produced from several themes depicting landscape
              conditions (i.e., forest cover, forest intactness, biological
              richness, biomass, social status, and energy prospects). The data
              corresponding to each theme was collected from the field or
              published literature, published datasets, or administrative
              reports.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/tl_weight.png" alt="" />
              ........(10){" "}
            </p>

            <p>
              Where n is the number of data sets, Q<sub>i</sub> is the quantity
              associated with criterion i, and W<sub>i</sub> is the weight
              associated with that measure. An indicator illustrates each
              measure represented by a normalized value between 10 to 2. The
              higher conservation priority was depicted by the value of 10, and
              the low conservation as 2. The intermediate values such as 8, 6,
              and 4 correspond to high, moderate, and low levels of
              conservation. The weights were based on a specific facto&rsquo;'s
              quantity assigned across grids. Grids based on the aggregation
              score were grouped into four groups (ESR 1-4) based on the mean
              and standard deviation. The groups were formed as ESR 1
              (aggregated score &gt; &micro;+2&sigma;), ESR 2 (for grids within
              &micro;+2&sigma; and &micro;+&sigma;), ESR 3 (for grids with&nbsp;
              &micro;+&sigma;&nbsp; and &micro;) and ESR 4 (grids with values
              &lt; &micro;).
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
